/*
 * Export component file to be used on project
*/

import ModalInvalidateRequest from './ModalInvalidateRequest.js'
export default ModalInvalidateRequest
